/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DnspControlInterval } from "./DnspControlInterval";
import {
    DnspControlIntervalFromJSON,
    DnspControlIntervalFromJSONTyped,
    DnspControlIntervalToJSON,
} from "./DnspControlInterval";

/**
 *
 * @export
 * @interface DnspDeviceControlIntervals
 */
export interface DnspDeviceControlIntervals {
    /**
     *
     * @type {string}
     * @memberof DnspDeviceControlIntervals
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DnspDeviceControlIntervals
     */
    deviceType?: string;
    /**
     * Continuous intervals for the whole time range, for this device. The `response.to` field is the end time of the last interval.
     * @type {Array<DnspControlInterval>}
     * @memberof DnspDeviceControlIntervals
     */
    controlIntervals?: Array<DnspControlInterval>;
}

/**
 * Check if a given object implements the DnspDeviceControlIntervals interface.
 */
export function instanceOfDnspDeviceControlIntervals(
    value: object,
): value is DnspDeviceControlIntervals {
    return true;
}

export function DnspDeviceControlIntervalsFromJSON(
    json: any,
): DnspDeviceControlIntervals {
    return DnspDeviceControlIntervalsFromJSONTyped(json, false);
}

export function DnspDeviceControlIntervalsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DnspDeviceControlIntervals {
    if (json == null) {
        return json;
    }
    return {
        deviceId: json["deviceId"] == null ? undefined : json["deviceId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        controlIntervals:
            json["controlIntervals"] == null
                ? undefined
                : (json["controlIntervals"] as Array<any>).map(
                      DnspControlIntervalFromJSON,
                  ),
    };
}

export function DnspDeviceControlIntervalsToJSON(
    value?: DnspDeviceControlIntervals | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceId: value["deviceId"],
        deviceType: value["deviceType"],
        controlIntervals:
            value["controlIntervals"] == null
                ? undefined
                : (value["controlIntervals"] as Array<any>).map(
                      DnspControlIntervalToJSON,
                  ),
    };
}
